import React, { useState } from 'react'
import car_img from "../Data/sample_images/vw_polo_1_new.png"

const SubscribeBlock = () => {
    // State to store email
    const [userEmail, setUserEmail] = useState({
        emailInput: ""
    })

    // Form to handle form event
    const handleSubscribeForm = (event) => {
        event.preventDefault()
        setUserEmail((prevObject) => {
            return {
                ...prevObject,
                [event.target.name]: event.target.value
            }
        })
    }

  return (
    <>
        <div className="subscribe-container">
            <div className="container subscribe-box">
                <div className="subscribe-img-container">
                    <img src={car_img} alt="rental-car" />
                </div>
                <div className="subscribe-info-container">
                    <h1 className="subscribe-title">Subscribe to our Newsletter!</h1>
                    <p className="subscribe-description">Subscribe to our Newsletter for our latest news on events, blogs & rental information!</p>
                    <form onChange={handleSubscribeForm} className='subscribe-form'>
                        <input type="email" name='emailInput' value={userEmail.emailInput} placeholder='enter your email' className='subscribe-input'/>
                        <button className="btn btn-md btn-light subscribe-btn" onClick={(event) => event.preventDefault()}>Subscribe</button>
                    </form>
                </div>
            </div>
        </div>
    </>
  )
}

export default SubscribeBlock